<p-card header="Contraseña" subheader="Cambia tu contraseña validando primero la actual.">
  <p-message severity="info" icon="pi pi-info-circle" text="Debe tener al menos 12 caracteres, 1 mayúscula, 1 número y 1 carácter especial."></p-message>

  <ng-template pTemplate="footer">
    <div class="flex justify-end">
      <p-button label="Cambiar contraseña" icon="pi pi-key" iconPos="left" severity="primary" (onClick)="openPasswordDialog.emit()"></p-button>
    </div>
  </ng-template>
</p-card>

<p-dialog
  header="Cambiar contraseña"
  [visible]="showPasswordDialog"
  (visibleChange)="!$event && closePasswordDialog.emit()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!changingPassword"
  styleClass="w-[min(92vw,36rem)]"
>
  <form [formGroup]="passwordForm" class="flex flex-col gap-4 pt-1" (ngSubmit)="submitPasswordChange.emit()">
    <div class="flex flex-col gap-2">
      <label for="currentPassword" class="font-bold">Contraseña actual</label>
      <p-password
        id="currentPassword"
        formControlName="currentPassword"
        [feedback]="false"
        [toggleMask]="true"
        inputStyleClass="w-full"
        styleClass="w-full"
      ></p-password>
    </div>
    <div class="flex flex-col gap-2">
      <label for="newPassword" class="font-bold">Nueva contraseña</label>
      <p-password id="newPassword" formControlName="newPassword" [toggleMask]="true" inputStyleClass="w-full" styleClass="w-full"></p-password>
      <small>Debe tener al menos 12 caracteres, 1 mayúscula, 1 número y 1 carácter especial.</small>
    </div>
    <div class="flex flex-col gap-2">
      <label for="confirmPassword" class="font-bold">Confirmar contraseña</label>
      <p-password
        id="confirmPassword"
        formControlName="confirmPassword"
        [feedback]="false"
        [toggleMask]="true"
        inputStyleClass="w-full"
        styleClass="w-full"
      ></p-password>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="flex flex-wrap items-center justify-between gap-2 w-full">
      <div class="flex gap-2">
        <p-button
          label="Cancelar"
          icon="pi pi-times"
          iconPos="left"
          severity="danger"
          variant="outlined"
          (onClick)="closePasswordDialog.emit()"
          [disabled]="changingPassword"
        ></p-button>
      </div>

      <div class="flex gap-2">
        <p-button
          label="Cambiar Contraseña"
          icon="pi pi-check"
          iconPos="left"
          severity="success"
          [loading]="changingPassword"
          [disabled]="passwordForm.invalid"
          (onClick)="submitPasswordChange.emit()"
        ></p-button>
      </div>
    </div>
  </ng-template>
</p-dialog>
